module.exports = __webpack_public_path__ + "assets/medium.3891be39.png";